<template>
    <div class="effect-lead-course">
        <div class="header">
            <span class="text">条件：</span>
            <Select v-model="classId" style="width:180px" clearable placeholder="请选择考试">
                <Option v-for="item in classIdList" :value="item.classID" :key="item.classID">{{ item.classCName }}</Option>
            </Select>
            <DatePicker v-model="time" class="ml-10" type="daterange" placement="bottom-end"  :editable='false' @on-change="times"
            placeholder="请选择开始时间，结束时间" style="width: 220px"></DatePicker>
            <Button class="ml-10" type="primary" @click="search">查询</Button>
            <Button class="ml-10" @click="resetSearch">重置</Button>
        </div>

        <div class="tbl">
            <Table class="mt-20" :columns="tableColumns" :data="tableData"></Table>
            <Page @on-change="pageChange" @on-page-size-change="pageSizeChange" :total="total" :page-size="params.pgSize"
                :current="params.pgIndex" show-total show-elevator show-sizer></Page>
        </div>
        
    </div>
</template>

<script>
export default {
    data(){
        return{
            time:[],
            classId:'',
            classIdList:[],
            tableColumns:[
                {
                    title: '用户名',
                    key: 'userName',
                    width: 200,
                    align:'center'
                },
                {
                    title: '领取考试',
                    key: 'classCName',
                    align:'center'
                },
                {
                    title: '领取课程',
                    key: 'myClassName',
                    align:'center'
                },
                {
                    title: '领取时间',
                    key: 'bM_TF_Time',
                    align:'center'
                }
            ],
            tableData:[],

            pgIndex:1,
            pgSize:10,
            total:0,
            params:{
                pgIndex: 1,
                pgSize: 10
            }
        }
    },
    created(){
        this.getExamdaClass()
        this.getLingKeOrderList()
    },
    methods:{
        // 点击查询
        search(){
            this.params = {
                pgIndex: 1,
                pgSize: 10,
            }
            if(this.time.length&&this.time[0]&&this.time[1]){
                this.params.startTime = this.time[0]
                this.params.endTime = this.time[1]
            }
            if(this.classId) this.params.classId = this.classId
            this.getLingKeOrderList()
        },

        // 清空搜索条件
        resetSearch(){
            this.classId = ''
            this.time = []
            this.params = {
                pgIndex: 1,
                pgSize: 10,
            }
            this.getLingKeOrderList()
        },

        // 获取表格数据
        getLingKeOrderList(){
            let params = this.params
            if(this.classId) params.classId = this.classId
            this.$store.dispatch('effect/getLingKeOrderList', params).then(res => {
                if (res.s === 10006){
                    this.tableData = res.list || []
                    this.total = res.count || 0
                }
            })
        },

        times(v){
            this.time = v
        },

        // 获取classId下拉表
        getExamdaClass(){
            this.$store.dispatch('effect/getExamdaClass',{}).then(res => {
                if (res.s === 10006){
                    this.classIdList = res.list || []
                }
            })
        },

        pageChange(val) {
            this.params.pgIndex = val;
            this.getLingKeOrderList();
        },
        pageSizeChange(val) {
            this.params.pgSize = val;
            this.getLingKeOrderList();
        },
    }
}
</script>

<style lang="scss" scoped>
.effect-lead-course{
    .ml-10{ margin-left: 10px }
    .mt-20{ margin-top: 20px }
    .tbl {
      .ivu-page {
        text-align: right;
        margin: 20px 0;
      }
    }
}
</style>